import React, { useEffect } from 'react';
import { object, bool } from 'prop-types';

import { initializeOptimizelyWithKey } from '../../utils/optimizely_helpers';

const GlobalActions = ({ currentUser, proUser, optimizelyKey }) => {
  const setUpTatari = () => {
    if (currentUser && window.tatari) {
      // Safety first - Wrap anything Tatari-related in a try/catch
      try {
        window.tatari.identify(currentUser.id);
      } catch (error) {
        console.error('Error setting up Tatari', error);
      }
    }
  };

  // In testing the pendo script tag has been slow to load so we
  // attempt up to 4 times every 750 ms to initialize the user.
  let pendoSetUpAttempts = 0;
  const maxPendoSetUpAttempts = 3;
  const pendoSetUpBackOff = 750;

  const setUpPendo = () => {
    if (!currentUser || pendoSetUpAttempts > maxPendoSetUpAttempts) {
      return;
    }

    if (window.pendo) {
      try {
        const visitor = {
          id: currentUser.id,
          pro: proUser
        };
        window.pendo.initialize({ visitor });
      } catch (error) {
        console.error('Error setting up Pendo', error);
      }
    } else {
      pendoSetUpAttempts += 1;
      setTimeout(setUpPendo, pendoSetUpBackOff);
    }
  };

  const setUpOptimizely = () => {
    try {
      if (optimizelyKey) {
        initializeOptimizelyWithKey(optimizelyKey);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setUpTatari();
  }, []);

  useEffect(() => {
    setUpPendo();
  }, []);

  useEffect(() => {
    setUpOptimizely();
  }, []);

  return <></>;
};

GlobalActions.propTypes = {
  currentUser: object,
  proUser: bool.isRequired
};

GlobalActions.defaultProps = {
  currentUser: null
};

export default GlobalActions;
